import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { Orderstatuspublic, SortDirection, CursorMode } from './Enums'
/**
* Class OrdersListRequestQuery
*  Query params for operation "OrdersList"
*/
export class OrdersListRequestQuery extends ActiveModel {

/**
  * ['Filter.StatusBefore']
  * Фильтр по времени назначения текущего статуса (не позднее, не включая)<br>
  */
  @ActiveField()
  ['Filter.StatusBefore']?: string


/**
  * ['Filter.StatusAfter']
  * Фильтр по времени назначения текущего статуса (не раньше, включительно)<br>
  */
  @ActiveField()
  ['Filter.StatusAfter']?: string


/**
  * ['Filter.Statuses']
  * Фильтр по статусам заказа.<br>Если null или пустой список, то вернуть все статусы<br>  */
  @ActiveField({
    setter(model: OrdersListRequestQuery, prop: string, value: Array<Orderstatuspublic> | undefined, receiver?: OrdersListRequestQuery ) {
      return Reflect.set(
        model,
        prop,
        value ?  (Array.isArray(value) ? value : [value]) : value, 
        receiver)
    }
  })
  ['Filter.Statuses']?: Array<Orderstatuspublic>


  /**
  * ['Filter.ShowDeleted']
  * Включить удалённые записи в результат<br>  */
  @ActiveField()
  ['Filter.ShowDeleted']?: boolean


/**
  * ['Filter.CreatedBefore']
  * Фильтр по дате создания (не позднее, не включая)<br>
  */
  @ActiveField()
  ['Filter.CreatedBefore']?: string


/**
  * ['Filter.CreatedAfter']
  * Фильтр по дате создания (не раньше, включительно)<br>
  */
  @ActiveField()
  ['Filter.CreatedAfter']?: string


/**
  * Query
  * Поисковый запрос<br>
  */
  @ActiveField()
  Query?: string


  /**
  * Limit
  * Кол-во элементов в результате. <br><br>Если значение меньше 1, то вернуть все элементы<br>  */
  @ActiveField()
  Limit?: number


/**
  * SortField
  * Поле для сортировки<br>
  */
  @ActiveField()
  SortField?: string


  /**
  * SortDirection
  * Направление сортировки<br>  */
  @ActiveField()
  SortDirection?: SortDirection


  /**
  * CursorMode
  * Режим курсора. Если значение указано, то необходимо<br>указывать Web.Core.Pagination.SortOptions.CursorField и Web.Core.Pagination.SortOptions.CursorId  */
  @ActiveField()
  CursorMode?: CursorMode


/**
  * CursorField
  * Значение Web.Core.Pagination.SortOptions.SortField первого/последнего элемента<br>(в зависимости от курсора Web.Core.Pagination.SortOptions.CursorMode),<br>полученное в рамках ответа на предыдущий курсорный запрос<br>
  */
  @ActiveField()
  CursorField?: string


/**
  * CursorId
  * Значение уникального ключа (чаще всего, но не обязательно, это id) первого/последнего элемента<br>(в зависимости от курсора Web.Core.Pagination.SortOptions.CursorMode),<br>полученное в рамках ответа на предыдущий курсорный запрос<br>
  */
  @ActiveField()
  CursorId?: string
}
